import * as React from 'react';

import { EPaymentStatus } from '../../types/payment';
import { PaymentCanceled, PaymentError, PaymentSuccess, PaymentPending } from './components';
import {
  PAYMENT_CANCELED_TEST_ID,
  PAYMENT_ERROR_TEST_ID,
  PAYMENT_PENDING_TEST_ID,
  PAYMENT_SUCCESS_TEST_ID,
} from './constants';
import { usePayment, usePaymentStatusSubscription } from './utils';

export const PaymentContainer: React.FC = () => {
  usePaymentStatusSubscription();
  const { paymentId, paymentStatus, finishAction, beginAgainAction } = usePayment();

  switch (paymentStatus) {
    case EPaymentStatus.Paid:
      return (
        <PaymentSuccess
          testId={PAYMENT_SUCCESS_TEST_ID}
          href={finishAction.url}
          paymentId={paymentId}
          onAction={finishAction.handler}
        />
      );
    case EPaymentStatus.Unpaid:
      return <PaymentPending testId={PAYMENT_PENDING_TEST_ID} />;
    case EPaymentStatus.Canceled:
      return (
        <PaymentCanceled
          testId={PAYMENT_CANCELED_TEST_ID}
          href={beginAgainAction.url}
          onAction={beginAgainAction.handler}
        />
      );
    default:
      return (
        <PaymentError testId={PAYMENT_ERROR_TEST_ID} href={beginAgainAction.url} onAction={beginAgainAction.handler} />
      );
  }
};
